export const keys = {
  enrollment: 'S*oFr#Sp=g6!LcUsT!Br',
}
